"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geo = void 0;
const tslib_1 = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var Geo_1 = require("./Geo");
Object.defineProperty(exports, "Geo", { enumerable: true, get: function () { return Geo_1.Geo; } });
tslib_1.__exportStar(require("./types"), exports);
